import React from 'react';
import { FoundationData } from '../../types/Foundation';
import { Download } from 'lucide-react';

interface DocumentPreviewProps {
  data: FoundationData;
  onBack: () => void;
  onDownload: () => void;
}

export function DocumentPreview({ data, onBack, onDownload }: DocumentPreviewProps) {
  return (
    <div className="bg-white rounded-xl shadow-lg p-8">
      <div className="mb-8">
        <h1 className="text-3xl font-bold text-gray-900 mb-4">{data.basicInfo.name}</h1>
        <p className="text-gray-600">{data.basicInfo.purpose}</p>
      </div>

      <div className="space-y-8">
        <section>
          <h2 className="text-xl font-semibold text-[#A3C1DA] mb-4">Grundläggande Information</h2>
          <div className="space-y-4">
            <div>
              <h3 className="font-medium text-gray-700">Typ av stiftelse</h3>
              <p>{data.basicInfo.type}</p>
            </div>
            <div>
              <h3 className="font-medium text-gray-700">Grundkapital</h3>
              <p>{data.basicInfo.startingCapital}</p>
            </div>
            <div>
              <h3 className="font-medium text-gray-700">Säte</h3>
              <p>{data.basicInfo.location}</p>
            </div>
          </div>
        </section>

        <section>
          <h2 className="text-xl font-semibold text-[#A3C1DA] mb-4">Styrelse och Förvaltning</h2>
          <div className="space-y-4">
            <div>
              <h3 className="font-medium text-gray-700">Styrelsemedlemmar</h3>
              <ul className="list-disc list-inside">
                {data.governance.boardMembers.map((member, index) => (
                  <li key={index}>{member.name} - {member.role}</li>
                ))}
              </ul>
            </div>
            <div>
              <h3 className="font-medium text-gray-700">Beslutsprocess</h3>
              <p>{data.governance.decisionMaking}</p>
            </div>
          </div>
        </section>

        <section>
          <h2 className="text-xl font-semibold text-[#A3C1DA] mb-4">Ekonomi och Revision</h2>
          <div className="space-y-4">
            <div>
              <h3 className="font-medium text-gray-700">Räkenskapsår</h3>
              <p>{data.financial.accountingPeriod}</p>
            </div>
            <div>
              <h3 className="font-medium text-gray-700">Revisionskrav</h3>
              <p>{data.financial.auditRequirements}</p>
            </div>
          </div>
        </section>

        <section>
          <h2 className="text-xl font-semibold text-[#A3C1DA] mb-4">Juridiska Aspekter</h2>
          <div className="space-y-4">
            <div>
              <h3 className="font-medium text-gray-700">Registreringsdetaljer</h3>
              <p>{data.legal.registrationDetails}</p>
            </div>
            <div>
              <h3 className="font-medium text-gray-700">Skattestatus</h3>
              <p>{data.legal.taxStatus}</p>
            </div>
          </div>
        </section>
      </div>

      <div className="mt-8 flex justify-end">
        <button
          onClick={onDownload}
          className="inline-flex items-center px-6 py-3 bg-[#A3C1DA] text-white rounded-lg
                   hover:bg-[#F2C1D1] transition-colors gap-2"
        >
          <Download className="w-5 h-5" />
          Ladda ner dokument
        </button>
      </div>
    </div>
  );
}